export const ThumbsUpIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    fill="none"
    viewBox="0 0 14 14"
  >
    <path
      stroke="currentColor"
      strokeWidth="1.5"
      d="M7.972 6.025h0a1.1 1.1 0 00.777.322h3.15a1.362 1.362 0 011.073.53 1.368 1.368 0
      01.234 1.17l-1.34 4.203-.003.01-.003.01a1.35 1.35 0 01-1.296.976s0 0 0 0H.75V6.347h1.374l.225-.276L6.516.966a.65.65
      0 011.017.063L8.15.6l-.616.428a.65.65 0 01.116.37v3.848c0 .292.116.572.323.778z"
    />
  </svg>
)
